import React from 'react';
import axios from 'axios';
import { ReqEditDeviceLan } from '../types/api/Devices';
import { ApiUrl } from '../conf/config';

export const useEditDeviceLan = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const editDeviceLan = (id: string, device: ReqEditDeviceLan) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    axios
      .put(`${ApiUrl}/admin/api/v1/devices/${id}/lan`, device, {
        headers: { Authorization: 'Bearer ' + token },
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { editDeviceLan, loading, error };
};
